import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { StorageKeys, local } from "../../utils/storage";
import { getCompany } from "../../config/companyConfig";
import { getAffariAlmacen } from "../../services/backend/authService";

const WarehouseContext = createContext();
export const useWarehouseContext = () => useContext(WarehouseContext);

const WarehouseProvider = ({ children }) => {
  const [almacenes, setAlmacenes] = useState([]);
  const [selectedAlmacen, setSelectedAlmacenState] = useState(
    () => local.get(StorageKeys.SELECTED_ALMACEN) || getAffariAlmacen() || getCompany().defaultWarehouse
  );

  const setSelectedAlmacen = useCallback((nextAlmacen = "") => {
    const normalized = String(nextAlmacen || "").trim();
    if (!normalized) {
      return;
    }
    setSelectedAlmacenState(normalized);
  }, []);

  useEffect(() => {
    local.set(StorageKeys.SELECTED_ALMACEN, selectedAlmacen);
  }, [selectedAlmacen]);

  const value = useMemo(() => ({
    almacenes,
    setAlmacenes,
    selectedAlmacen,
    setSelectedAlmacen,
  }), [almacenes, selectedAlmacen, setSelectedAlmacen]);

  return (
    <WarehouseContext.Provider value={value}>
      {children}
    </WarehouseContext.Provider>
  );
};

export default WarehouseProvider;
